import 'core-js/stable';
import 'regenerator-runtime/runtime';
import cssVars from 'css-vars-ponyfill';
import Vue from 'vue';
import Notifications from 'vue-notification';
import VueNativeSock from 'vue-native-websocket';
import { library } from '@fortawesome/fontawesome-svg-core';
import * as Sentry from '@sentry/vue';
import VueWorker from 'vue-worker';
import VueGtag from 'vue-gtag';

process.env.VUE_APP_ENVIRONMENT !== 'local' && Sentry.init({
  Vue,
  dsn: "https://529891733acc4f3994caa513bfdf481e@o109565.ingest.sentry.io/5554712",
  autoSessionTracking: true,
  environment: process.env.VUE_APP_ENVIRONMENT
});

import {
  faAngleLeft,
  faPaperPlane,
  faSmile, 
  faSpinner,
  faPaperclip,
  faPlug,
  faTimes,
  faTimesCircle,
  faTrash,
  faComments,
  faCheck,
  faCertificate,
  faExclamationCircle,
  faCheckCircle,
  faEnvelope,
  faThumbtack,
  faEyeSlash,
  faSearch,
  faPhoneSlash,
  faMicrophone,
  faMicrophoneSlash,
  faVideoSlash,
  faReply,
  faIcons,
  faVideo,
  faPhone,
  faMicrophoneAlt
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import linkify from 'vue-linkify';
import VModal from 'vue-js-modal';

import App from './App';
import store from './store';

cssVars();
Vue.config.productionTip = false;

library.add(faAngleLeft);
library.add(faSpinner);
library.add(faPaperPlane);
library.add(faPlug);
library.add(faSmile);
library.add(faPaperclip);
library.add(faTimes);
library.add(faTimesCircle);
library.add(faTrash);
library.add(faComments);
library.add(faCheck);
library.add(faCertificate);
library.add(faExclamationCircle);
library.add(faCheckCircle);
library.add(faEnvelope);
library.add(faThumbtack);
library.add(faEyeSlash);
library.add(faSearch);
library.add(faPhoneSlash);
library.add(faMicrophone);
library.add(faMicrophoneSlash);
library.add(faVideoSlash);
library.add(faReply);
library.add(faIcons);
library.add(faVideo);
library.add(faPhone);
library.add(faMicrophoneAlt);
Vue.component('fa-icon', FontAwesomeIcon);

Vue.use(VModal);
Vue.use(VueWorker);

Vue.directive('linkified', linkify);

Vue.use(Notifications)
Vue.use(require('vue-moment'));
Vue.use(VueNativeSock, process.env.VUE_APP_AWS_WEBSOCKET_URL, {
  store,
  format: 'json',
  reconnection: true,
  reconnectionDelay: 2000
});

process.env.VUE_APP_ENVIRONMENT !== 'local' && Vue.use(VueGtag, {
  config: { id: 'UA-56776616-7' }
});

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
